import './carousel.scss';

import * as gzCarouselDirective from './carousel.directive';
import angularTranslate from 'angular-translate';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';

export default angular.module('gazelle.components.carousel', [
  angularTranslate,
  gazelleAnalytics,
])
  .directive(gzCarouselDirective.name, gzCarouselDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/carousel.module.js